import React, { useState } from "react";
import Button from "../../../components/Button";
import { API_POST, API_PATCH, API_PUT } from "../../../helpers/api";
import { setNotification } from "../../../helpers/notification";
export default function JOBS() {
  const [loadingBilateral, setLoadingBilateral] = useState(false);
  const [loadingRedemption, setLoadingRedemption] = useState(false);
  const [loadingCancelAllOrders, setLoadingCancelAllOrders] = useState(false);
  const [loadingIlga, setLoadingIlga] = useState(false);
  const [loadingRcg, setLoadingRcg] = useState(false);
  const [processParticipationFee, setProcessParticipationFee] = useState(false);
  const [loadingRrcg, setLoadingRrcg] = useState(false);

  const runBilateral = async () => {
    try {
      setLoadingBilateral(true);
      await API_POST("bilateralAgreement/execute-aggrements");
      setNotification("success", "İkili anlaşma JOB başarıyla gerçekleşti");
      setLoadingBilateral(false);
    } catch (error) {
      setNotification("error", error.response.data.message);
      setLoadingBilateral(false);
    }
  };
  const runRedemption = async () => {
    try {
      setLoadingRedemption(true);
      await API_PATCH("certificate/redemption");
      setNotification("success", "İtfa İşlemleri JOB başarıyla gerçekleşti");
      setLoadingRedemption(false);
    } catch (error) {
      if (error.response) {
        setNotification("error", error.response.data.message);
      } else {
        setNotification("error", "Bilinmeyen hata oluştu");
      }
      setLoadingRedemption(false);
    }
  };
  const runCancelAllOrders = async () => {
    try {
      setLoadingCancelAllOrders(true);
      await API_PUT("exchange-order/cancelAllOrders");
      setNotification("success", "Seans Sonu JOB başarıyla gerçekleşti");
      setLoadingCancelAllOrders(false);
    } catch (error) {
      if (error.response) {
        setNotification("error", error.response.data.message);
      } else {
        setNotification("error", "Bilinmeyen hata oluştu");
      }
      setLoadingCancelAllOrders(false);
    }
  };
  const runIlga = async () => {
    try {
      setLoadingIlga(true);
      await API_PATCH("certificate");
      setNotification(
        "success",
        "Tüm Siparişleri İptal Etmesi JOB başarıyla gerçekleşti"
      );
      setLoadingIlga(false);
    } catch (error) {
      if (error.response) {
        setNotification("error", error.response.data.message);
      } else {
        setNotification("error", "Bilinmeyen hata oluştu");
      }
      setLoadingIlga(false);
    }
  };
  const runRcg = async () => {
    try {
      setLoadingRcg(true);
      await API_POST("exchange-job/notify-rcg");
      setNotification("success", "RCG işlemi gerçekleşti");
      setLoadingIlga(false);
    } catch (error) {
      if (error.response) {
        setNotification("error", error.response.data.message);
      } else {
        setNotification("error", "Bilinmeyen hata oluştu");
      }
      setLoadingRcg(false);
    }
  };
  const runRrcg = async () => {
    try {
      setLoadingRcg(true);
      await API_POST("exchange-job/release-rcg");
      setNotification("success", "RRCG işlemi gerçekleşti");
      setLoadingIlga(false);
    } catch (error) {
      if (error.response) {
        setNotification("error", error.response.data.message);
      } else {
        setNotification("error", "Bilinmeyen hata oluştu");
      }
      setLoadingRcg(false);
    }
  };
  const runProcessParticipationFee = async () => {
    try {
      setProcessParticipationFee(true);
      await API_PATCH(
        "organization/registration/process-annual-participation-fee"
      );
      setNotification("success", "Yıllık Katılım Ücreti");
    } catch (error) {
      if (error.response) {
        setNotification("error", error.response.data.message);
      } else {
        setNotification("error", "Bilinmeyen hata oluştu");
      }
      setProcessParticipationFee(false);
    }
  };
  return (
    <div>
      <h4 style={{ marginBottom: "20px" }}>JOB ÇALIŞTIR</h4>
      <div className={"job-container"} style={{ display: "flex" }}>
        <Button
          label="İkili Anlaşma"
          onClick={runBilateral}
          disabled={loadingBilateral}
        />
        <Button
          label="İtfa İşlemleri"
          onClick={runRedemption}
          disabled={loadingRedemption}
        />
        <Button
          label="Seans Sonu"
          onClick={runCancelAllOrders}
          disabled={loadingCancelAllOrders}
        />
        <Button label="İlga" onClick={runIlga} disabled={loadingIlga} />
        <Button
          label="RCG (Mevcut Teminatların Gönderimi)"
          onClick={runRcg}
          disabled={loadingRcg}
        />
        <Button
          label="Release RCG (Tüm Teminatların 0 Gönderimi)"
          onClick={runRrcg}
          disabled={loadingRrcg}
        />
        <Button
          label="Süreç Yıllık Katılım Ücreti"
          onClick={runProcessParticipationFee}
          disabled={processParticipationFee}
        />
      </div>
    </div>
  );
}
